export var IdDoghouseTreatPackage;
(function (IdDoghouseTreatPackage) {
    IdDoghouseTreatPackage[IdDoghouseTreatPackage["Standard"] = 34] = "Standard";
    IdDoghouseTreatPackage[IdDoghouseTreatPackage["Premium"] = 50] = "Premium";
})(IdDoghouseTreatPackage || (IdDoghouseTreatPackage = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/doghouse/IdDoghouseTreatPackage.ts
// module id = 831
// module chunks = 3